import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import About from '../components/About';
import Education from '../components/Education';
import Honors from '../components/Honors';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Certifications from '../components/Certifications';
import Projects from '../components/Projects';
import Research from '../components/Research';
import Services from '../components/Services';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // If there's a hash in the URL, scroll to that section
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      // Otherwise, scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <Hero />
      <About />
      <Education />
      <Honors />
      <Experience />
      <Skills />
      <Certifications />
      <Projects />
      <Research />
      <Services />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
